<template>
    <section class="tool-holder">
        <div class="tool-container">
            <div class="tool__question-holder">
                <h3 class="tool__subtitle">{{ question.number }}</h3>
                <h2 class="tool__title">{{ question.title }}</h2>
                <div class="tool__text-holder" v-if="question.text">
                    <p class="tool__text">{{ question.text }}</p>
                </div>
            </div>
            <div class="tool__answer-holder tool__answer-holder--center radio-button-container" :class="{'radio-button-container--quad' : question.slug === 'energielabel'}">
                <div v-for="(answer, index) in question.answers" :key="question.slug + index" class="radio-button-holder radio-button-holder--image radio-button-holder--boxed radio-button-holder--triple" :class="{'radio-button-holder--quad' : question.slug === 'energielabel', 'radio-button-holder--double' : question.slug === 'type-dak','success' : answers[0] === answer.text }" @click="addToStore(answer.text)">
                    <i class="tool__radio-question-icon">
                        <img :src="`/media/images/tool/icons/${answer.icon}.svg`" :alt="answer.icon" />
                    </i>
                    <input
                        :id="answer.text"
                        type="radio"
                        :name="question.slug"
                        :ref="answer.text"
                        :checked="answers[0] === answer.text"
                    />
                    <label :for="answer.text">{{ answer.text }}</label>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import store from '../../store/store';

export default {
    props: {
        question: {
            type: Object
        }
    },

    data() {
        return {
            store,
            answers: null,
        }
    },

    created() {
        // this.answers = this.store.questionAnswers[this.store.currentQuestionIndex];
        this.answers = this.question.isSideQuestion ? this.store.questionAnswers[this.store.currentQuestionIndex].sideQuestions.answers[this.store.currentSideQuestionIndex] : this.store.questionAnswers[this.store.currentQuestionIndex].answers;
    },

    methods: {
        addToStore(value) {
            const radio = this.$refs[value][0];
            radio.click();
            this.answers = [value];

            if (this.question.slug == 'gezins-samenstelling') {
                const estimatedConsumption = this.estimateConsumption();
                this.store.questionAnswers[this.store.currentQuestionIndex].answers = [estimatedConsumption.gas, estimatedConsumption.energy];
            }

            if (this.question.isSideQuestion) {
                this.store.questionAnswers[this.store.currentQuestionIndex].sideQuestions.answers[this.store.currentSideQuestionIndex] = this.answers;
                return;
            }

            this.store.questionAnswers[this.store.currentQuestionIndex].answers = this.answers;
        },

        /**
         * Returns estimation of gas and energy consumption.
         * 
         * @returns {Object} {energy: int, gas: int}
         */
        estimateConsumption() {

            // Define energy consumption by number of residents.
            const energyTable = {
                '1 persoon': '1825',
                '2 personen': '2860',
                '3 personen': '3400',
                '4 personen': '3930',
                '5 personen': '4180',
                '6+ personen': '5000',
            }
            const energy = energyTable[this.answers[0]];

            // Define gas consumption based on residence type.
            const gasTable = {
                'vrijstaand': '2200',
                '2 onder 1 kap': '1710',
                'hoekwoning': '1510',
                'tussenwoning': '1290',
                'benedenwoning': '990',
                'bovenwoning': '990',
            }
            const gas = gasTable[this.store.questionAnswers[0].answers[0]];

            return {
                energy: energy,
                gas: gas,
            };
        },
    },

    updated() {
        // Reset answers for when there are multiple radio questions after each other. This will prevent the template to have a success class on the fields when the user hasn't selected anything
        this.answers = this.question.isSideQuestion ? this.store.questionAnswers[this.store.currentQuestionIndex].sideQuestions.answers[this.store.currentSideQuestionIndex] : this.store.questionAnswers[this.store.currentQuestionIndex].answers;
    }
}
</script>
